
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/crowdtwist",
      function () {
        return require("private-next-pages/destinations/crowdtwist.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/crowdtwist"])
      });
    }
  